import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { DisputeData } from "../types";

export const updateDisputeApi = (userId: string, dispute: DisputeData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "clearing/upddispsit",
    params: {
      userId,
    },
    data: dispute,
  });

export default updateDisputeApi;
